import React, { useEffect, useState } from 'react';

import { Stack, Typography, Link, Box, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Loader } from 'components/Loader';
import { ListItem } from '../components/JobAdsSectionListItem';
import { useGetAll } from '../api/getAllJobAds';
import { paths } from 'routes';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { IconWrapper } from 'components/Icon';
import { LookingForMore } from './JobAdsLookingForMore';

export const JobAdsSection = ({label, count = 8, currentPostID = null}) => {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('website:homepage.jobAdsSection.defaultLabel');
  const [page, setPage] = useState(1);

  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);
  const [itemsToMap, setItemsToMap] = useState([]);

  const location = useLocation();
  const websiteContext = location?.state?.websiteContext || 'suppliers';

  const {
    data: { jobAds, total },
    refetch: refetchJobAds,
    isFetching,
  } = useGetAll({
    page: 0,
    limit: count,
    queryOptions: {
      onSettled: () => {
        clearTimeout(timer);
        setTimeout(() => setLoading(false), 1000);
      }
    },
  });

  useRefetch();

  useEffect(() => {
    if (isFetching) {
      const timeoutId = setTimeout(() => setLoading(true), 500);
      setTimer(timeoutId);
    } else {
      clearTimeout(timer);
    }

    return () => clearTimeout(timer);
  }, [isFetching]);

  const theme = useTheme();

  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  let maxRegularItems;

  if (isLg) {
      maxRegularItems = 7; 
  } else if (isMd) {
      maxRegularItems = 5; 
  } else {
      maxRegularItems = 7; 
  }

  const itemWidthStyles = {
    flexGrow: 0,
    flexShrink: 0,
    width: { 
      xs: '100%', 
      md: 'calc(33.3333% - 10.67px)', 
      lg: 'calc(25% - 12px)', 
    },
  };

  useEffect(() => {
    if (jobAds) {
      const itemsToMap = jobAds.slice(0, maxRegularItems);
      setItemsToMap(itemsToMap);
    }
  }, [jobAds]);

  if (!jobAds || jobAds.length === 0) {
    return null;
  }
  

  return (
      <Stack
        sx={{
          display: "flex",
          gap: 8,
          maxWidth: "100vw",
          alignItems: {xs: "center", md: "flex-start"},
        }}
      >
        <Stack gap={2} flexDirection={{xs: "column", md: "row"}} alignSelf={"center"}>      
          <Typography
            flex={1}
            variant='h3'
            sx={{
              fontSize: {xs: "1.5625rem", md: "2.5rem"},
              fontWeight: 600,
              lineHeight: 1.45,
              letterSpacing: 0,
              wordWrap: 'break-word',
              alignSelf: "center",
              textAlign: {xs: "center", md: "start"},
            }}
          >
            {resolvedLabel}
          </Typography>
        </Stack>
          {isFetching && !loading ? 
          (
            <></>
          ) :
          (!isFetching || (isFetching && loading)) ?
          (
            <>
            {loading && (
              <Loader style={{ marginTop: "20vh"}}/>
            )}
          
            {!loading && (
              <Stack flexDirection={"column"} gap={1} maxWidth={{xs: 366, md: "none"}} boxSizing={"border-box"} sx={{mx: {xs:4, md: 0}}}>
                {/* <Stack flexDirection={{xs: "column", md: "row"}} gap={2}>
                  {jobAds.length > 0 && (
                    jobAds.map((item) => (
                      <ListItem key={item.ad_id} {...item} websiteContext={websiteContext} />
                    ))
                  )}
                </Stack> */}
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    flexDirection: { xs: 'column', md: 'row' },
                  }}
                >
                  {itemsToMap.map((item) => (
                    <Box key={item.ad_id} sx={itemWidthStyles}>
                      <ListItem {...item} />
                    </Box>
                  ))}
                  <Box key="custom-item-slot" sx={itemWidthStyles}>
                    <LookingForMore />
                  </Box>
                </Box>
              </Stack>
            )}
            </>
          ) :
          (
            <></>
          )}
        </Stack>
  );

  function useRefetch() {
    useEffect(() => {     
      refetchJobAds();
    }, [page]);
  }
};
